export const CouldNotConnectToAccountTitleText = "mkc";
export const MailMessageFileProviderDisplayName = "nkc";
export default {CouldNotConnectToAccountTitleText,MailMessageFileProviderDisplayName};